import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MonthlyThroughputPerHourChart from "../components/MonthlyThroughputPerHourChart";
import DateSelector from "../components/DateSelector";
import MonthlyViewLayout from "../components/MonthlyViewLayout";
import { toMonthStart } from "../utils/month";
import { formatLocalDate } from "../utils/localDateTime";

const MonthlyThroughputPerHourPage = () => {
  const { date } = useParams();
  const navigate = useNavigate();
  const rawDate = date || formatLocalDate(new Date());
  const selectedDate = toMonthStart(rawDate);
  const [chartLoading, setChartLoading] = useState(true);

  // Reset loading states when date changes
  useEffect(() => {
    setChartLoading(true);
  }, [selectedDate]);

  useEffect(() => {
    if (!date || date !== selectedDate) {
      navigate(`/chart/monthly/throughput-per-hour/${selectedDate}`, { replace: true });
    }
  }, [date, selectedDate, navigate]);

  const handleDateChange = useCallback((newDate) => {
    navigate(`/chart/monthly/throughput-per-hour/${newDate}`);
  }, [navigate]);

  // Check if any data is still loading
  const isAnyLoading = chartLoading;

  return (
    <MonthlyViewLayout date={selectedDate}>
      <DateSelector date={selectedDate} setDate={handleDateChange} disabled={isAnyLoading} mode="month" />
      <MonthlyThroughputPerHourChart date={selectedDate} onLoadingChange={setChartLoading} />
    </MonthlyViewLayout>
  );
};

export default MonthlyThroughputPerHourPage;
